import { palette } from '../base/color';

// eslint-disable-next-line import/prefer-default-export
export const icon = {
  color: palette.gray[700],
  hover: {
    color: palette.squidInk,
  },
};
